/**
 * Разбор дат, приходящих от бэкенда.
 *
 * Жил в центре уведомлений (`notification-center/model/describe`), переехал
 * сюда, когда ту же дату понадобилось показывать в ленте событий заявки на
 * релиз: копия разбора неминуемо разъехалась бы с оригиналом, а цена ошибки
 * здесь — молчаливый сдвиг времени на часовой пояс пользователя.
 */
/**
 * Разобрать серверную дату как UTC. Бэкенд отдаёт НАИВНЫЙ UTC-таймстамп без
 * суффикса зоны (например "2026-07-31T07:04:49.123456"). `new Date()` трактует
 * такую строку как ЛОКАЛЬНОЕ время → сдвиг на TZ пользователя (уведомление «5
 * секунд назад» показывалось как «3 ч назад» в UTC+3). Если в строке нет
 * обозначения зоны (Z или ±HH:MM) — дописываем Z, считая её UTC.
 */
export const parseServerDate = (iso) => {
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
    return new Date(hasTz ? iso : `${iso}Z`);
};
